module.exports = __webpack_public_path__ + "static/media/general.689cd785.svg";